<template>
  <div class="show-box">{{ value }}</div>
</template>

<script lang="ts" setup>
import {computed, defineProps} from 'vue';
import {DateFieldType} from '@/components/business/crud/interface/FieldType';
import dayjs from 'dayjs';
import _ from 'lodash';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";

const props = defineProps<{
  propName: string;
  widget: DateFieldType;
  info: WidgetInfo;
  data: any;
}>();

const value = computed(() => {
  const date = props.data[props.propName];
  if (date !== undefined && date !== null) {
    return dayjs(_.toNumber(date)).format(
        props.widget.format || "YYYY-MM-DD"
    );
  } else {
    return '';
  }
})
</script>

<style lang="scss" scoped>
.show-box {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: $font-size-small;
}
</style>
